import { useUserBalances } from '@givebacks/api/ledger';
import { TransferAccountsModalGroup } from 'core/Components';
import { BalanceCard } from 'ui';

const WalletBalanceCard = () => {
  const { data: balance, isLoading } = useUserBalances();

  return (
    <TransferAccountsModalGroup
      openButton={(props) => (
        <BalanceCard
          title="Wallet"
          withBackgroundImage={true}
          available={balance?.available}
          pending={balance?.pending?.amount}
          isLoading={isLoading}
          onClick={() => props.openModalById('AvailableBalance')}
        />
      )}
    />
  );
};

export { WalletBalanceCard };
